/**
 * Filters component
 */

import React, { useState } from "react";
import Select from "react-select";

import SearchInput from "../search-results/search-input";

const locations = [
  { value: "", label: "Kaikki" },
  { value: "10", label: "Toscana" },
  { value: "11", label: "Umbria" },
  { value: "9", label: "Marche" },
  { value: "12", label: "Lazio" },
  { value: "19", label: "Sisilia" },
  { value: "other", label: "Muut" },
];

const holidayTypes = [
  { value: "", label: "Kaikki" },
  { value: "4", label: "Villa" },
  { value: "6", label: "Luxus" },
  { value: "11", label: "Romanttinen" },
  { value: "7", label: "Juhlahuvila" },
  { value: "1", label: "Rannikko" },
  { value: "8", label: "Viinitila" },
  { value: "5", label: "Huoneisto" },
];

const sizes = [
  { value: "", label: "Kaikki" },
  { value: "2:4", label: "2-4 vierasta" },
  { value: "5:7", label: "5-7 vierasta" },
  { value: "8:9", label: "8-9 vierasta" },
  { value: "10:13", label: "10-13 vierasta" },
  { value: "14:26", label: "14-26 vierasta" },
];

const prices = [
  { value: "", label: "Kaikki" },
  { value: "0:1000", label: "alle 1000 €/vko" },
  { value: "1000:2000", label: "1000-2000 €/vko" },
  { value: "2000:3000", label: "2000-3000 €/vko" },
  { value: "3000:4000", label: "3000-4000 €/vko" },
  { value: "4000:99999", label: "yli 4000 €/vko" },
];

const features = [
  {
    value: "pool",
    label: "Uima-allas",
  },
  {
    value: "internet",
    label: "Internet",
  },
  {
    value: "ac",
    label: "Ilmastointi",
  },
  {
    value: "shop-close",
    label: "Palvelut lähellä",
  },
];

const Filters = ({
  disabledFilters,
  search,
  region,
  property_type,
  price,
  size,
  features_values,
  has_discounts,
  diamond_deal,
  onChange,
  onChangeDisabledFilters,
  isLoading,
}) => {
  const state = {
    search: search,
    region: locations.find(element => {
      return element.value === region;
    }),
    property_type: holidayTypes.find(element => {
      return element.value === property_type;
    }),
    size: sizes.find(element => {
      return element.value === size;
    }),
    price: prices.find(element => {
      return element.value === price;
    }),
    features: features.filter(element => {
      return features_values && features_values.includes(element.value);
    }),
    has_discounts,
    diamond_deal,
  };

  const [searchInputState, setSearchInputState] = useState(state.search);

  const handleTextInputChange = () => {
    onChange({ search: searchInputState });
  };

  const handleInputChange = (value, event) => {
    const newState = {
      [event.name]: value.value,
      search: searchInputState,
    };
    handleStateChange(event.name, newState);
  };

  const handleFeaturesChange = (value, event) => {
    let newState;
    if (!value) {
      newState = {
        [event.name]: null,
        search: searchInputState,
      };
    } else {
      newState = {
        [event.name]: value.map(({ value }) => value),
        search: searchInputState,
      };
    }

    handleStateChange(event.name, newState);
  };

  const handleCheckboxInputChange = e => {
    const name = e.currentTarget.getAttribute("name");
    const newState = {
      [e.currentTarget.getAttribute("name")]: !state[
        e.currentTarget.getAttribute("name")
      ]
        ? true
        : null,
      search: searchInputState,
    };
    handleStateChange(name, newState);
  };

  const handleStateChange = (name, newState) => {
    if (!disabledFilters || !disabledFilters[name]) {
      onChange(newState);
    } else {
      onChangeDisabledFilters(newState);
    }
  };

  const selectStyles = {
    menu: provided => ({ ...provided, zIndex: 31 }),
  };

  return (
    <>
      <form action="#" autoComplete="off">
        <div className="row">
          <div className="col-xl-3 col-md-6 mb-4">
            <label htmlFor="search" className="form-label">
              Hae nimellä
            </label>
            <div className="col p-1">
              <SearchInput
                className="form-control"
                name="search"
                placeholder="Hae nimellä"
                value={searchInputState}
                onChange={e => {
                  setSearchInputState(e.target.value);
                }}
                onSubmit={e => {
                  handleTextInputChange(searchInputState);
                }}
                // onBlur={() => {
                //   if (searchInputState !== value) {
                //     onChange(searchInputState);
                //   }
                // }}
              />
            </div>
          </div>
          <div className="col-xl-3 col-md-6 mb-4">
            <label htmlFor="region" className="form-label">
              Maakunnat
            </label>
            <Select
              className="col p-1"
              placeholder="Maakunnat"
              name="region"
              value={state.region}
              options={locations}
              onChange={handleInputChange}
              isDisabled={isLoading}
              styles={selectStyles}
            />
          </div>
          <div className="col-xl-3 col-md-6 mb-4">
            <label htmlFor="property_type" className="form-label">
              Majoitustyypit
            </label>
            <Select
              className="col p-1"
              name="property_type"
              value={state.property_type}
              placeholder="Majoitustyypit"
              options={holidayTypes}
              onChange={handleInputChange}
              isDisabled={isLoading}
              styles={selectStyles}
            />
          </div>
          <div className="col-xl-3 col-md-6 mb-4">
            <label htmlFor="size" className="form-label">
              Kokovaihtoehdot
            </label>
            <Select
              className="col p-1"
              name="size"
              value={state.size}
              placeholder="Kokovaihtoehdot"
              options={sizes}
              onChange={handleInputChange}
              isDisabled={isLoading}
              styles={selectStyles}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xl-4 col-md-4 mb-4">
            <label htmlFor="price" className="form-label">
              Hinta
            </label>
            <Select
              className="col p-1"
              name="price"
              value={state.price}
              placeholder="Hinta"
              options={prices}
              onChange={handleInputChange}
              isDisabled={isLoading}
              styles={selectStyles}
            />
          </div>
          <div className="col-xl-8 col-md-8 mb-4">
            <div>
              <label htmlFor="deals" className="form-label">
                Deals
              </label>
              <ul className="list-inline mb-0 mt-1 d-flex justify-content-between">
                <li className="list-inline-item">
                  <div
                    name="has_discounts"
                    className="custom-control custom-switch"
                    onClick={handleCheckboxInputChange}
                  >
                    <input
                      className="custom-control-input"
                      type="checkbox"
                      name="has_discounts"
                      checked={!!state.has_discounts}
                      disabled={isLoading}
                      readOnly
                    />
                    <label
                      htmlFor="has_discounts"
                      className="custom-control-label"
                    >
                      <span className="text-sm">Tarjoukset & Last Minute</span>
                    </label>
                  </div>
                </li>
                <li className="list-inline-item">
                  <div
                    name="diamond_deal"
                    className="custom-control custom-switch"
                    onClick={handleCheckboxInputChange}
                  >
                    <input
                      className="custom-control-input"
                      type="checkbox"
                      name="diamond_deal"
                      checked={!!state.diamond_deal}
                      disabled={isLoading}
                      readOnly
                    />
                    <label
                      htmlFor="diamond_deal"
                      className="custom-control-label"
                    >
                      <span className="text-sm">Diamond Deal</span>
                    </label>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col">
            <label htmlFor="size" className="form-label">
              Varustelu
            </label>
            <Select
              className="col p-1"
              name="features"
              value={state.features}
              placeholder="Features"
              isMulti
              options={features}
              onChange={handleFeaturesChange}
              isDisabled={isLoading}
              styles={selectStyles}
            />
          </div>
        </div>
      </form>
    </>
  );
};
export default Filters;
